const logger = () => {
    return (storeAPI) => {
        return (next) => async (action) => {
            // console.log("Action Pass - ", action.type)
            return next(action);
        };
    };
};

export default logger;
